import {
    FETCH_SELLER_SERVICES,
      UPDATE_SELLER_SERVICE  }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [], fetched:false, total:0 };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_SELLER_SERVICES:
           // console.log('in FETCH_SELLER_SERVICES',action.payload );
             return {
                ...state,
                data: action.payload.data,
                total: action.payload.total,
                 fetched:true,
            }

        case UPDATE_SELLER_SERVICE:
          //  console.log('UPDATE_SELLER_SERVICE', state,  action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload._id});

            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                action.payload,
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                data: updatedProducts
            }



        default:
            return state;
    }
}

export const getRecord = (state, id) => {
     return state.adminServices.data.filter(record => record._id === id)[0];
}